import { createReduxModule } from "hooks-for-redux";
import { Game, GameReviewPosition } from "@chesshotel/types";

export interface Move {
  from: string;
  to: string;
}

export interface AnalysisMove {
  pos: string;
  from: string;
  to: string;
}

export interface AnalysisMoveDone extends AnalysisMove {
  depth: number;
  score?: number;
  bestScore?: number;
  type: string;
  bestMove?: string;
  ponder?: string;
}

interface AnalysisState {
  gameReview: GameReviewPosition[];
  gameReviewDone: boolean;
  bestMoves: string[];
  depth: number;
  analyzedGame: AnalysisMoveDone[];
  fullGame?: AnalysisMove[];
  game: Game;
  playingWhite?: boolean;
  positionIndex: number;
  gameLength: number;
  currentGameId?: number;
  analysisPossible: boolean;
  lastMove?: Move;
  bestMove?: Move;
  elo: number;
  startFen: string;
}

// export const gameReview: GameReviewPosition[] = [
//   {
//     fen: "rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq e3",
//     move: "e2e4",
//     depth: 18,
//     score: 0.26,
//     expectedPoints: 0.52,
//     type: MoveType.EXCELLENT,
//     // nextBestMove: "c7c5",
//     bestMove: "d2d4",
//   },
//   {
//     fen: "rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq e6",
//     move: "e7e5",
//     depth: 18,
//     score: 0.08,
//     expectedPoints: 0.51,
//     type: MoveType.EXCELLENT,
//     // nextBestMove: "g1f3",
//     bestMove: "c7c5",
//   },
//   {
//     fen: "rnbqkbnr/pppp1ppp/8/4p3/4P3/5Q2/PPPP1PPP/RNB1KBNR b KQkq -",
//     move: "d1f3",
//     depth: 18,
//     score: -0.04,
//     expectedPoints: 0.5,
//     type: MoveType.EXCELLENT,
//     // nextBestMove: "g8f6",
//     bestMove: "g1f3",
//   },
//   {
//     fen: "r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5Q2/PPPP1PPP/RNB1KBNR w KQkq -",
//     move: "b8c6",
//     depth: 18,
//     score: -0.25,
//     expectedPoints: 0.48,
//     type: MoveType.GOOD,
//     // nextBestMove: "f1c4",
//     bestMove: "g8f6",
//   },
//   {
//     fen: "r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5Q2/PPPP1PPP/RNB1K1NR b KQkq -",
//     move: "f1b5",
//     depth: 18,
//     score: -0.04,
//     expectedPoints: 0.5,
//     type: MoveType.EXCELLENT,
//     // nextBestMove: "c6d4",
//     bestMove: "f1c4",
//   },
//   {
//     fen: "r1bqkbnr/pppp1ppp/8/1B2p3/3nP3/5Q2/PPPP1PPP/RNB1K1NR w KQkq -",
//     move: "c6d4",
//     depth: 18,
//     score: -1.81,
//     expectedPoints: 0.37,
//     type: MoveType.BEST,
//     // nextBestMove: "f3d3",
//     bestMove: "c6d4",
//   },
//   {
//     fen: "r1bqkbnr/pppp1ppp/8/1B2p3/3nP3/8/PPPP1PPP/RNBQK1NR b KQkq -",
//     move: "f3d1",
//     depth: 18,
//     score: -0.89,
//     expectedPoints: 0.43,
//     type: MoveType.EXCELLENT,
//     // nextBestMove: "d4b5",
//     bestMove: "f3d3",
//   },
//   {
//     fen: "r1bqkbnr/pppp1ppp/8/1n2p3/4P3/8/PPPP1PPP/RNBQK1NR w KQkq -",
//     move: "d4b5",
//     depth: 18,
//     score: -2.67,
//     expectedPoints: 0.31,
//     type: MoveType.BEST,
//     // nextBestMove: "g1f3",
//     bestMove: "d4b5",
//   },
//   // {
//   //   fen: "r1bqkbnr/pppp1ppp/8/1n2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq -",
//   //   move: "g1f3",
//   //   depth: 18,
//   //   score: -2.39,
//   //   expectedPoints: 0.33,
//   //   type: 6,
//   //   // nextBestMove: "d7d5",
//   //   bestMove: "g1f3",
//   // },
// ];

const initialState: AnalysisState = {
  gameReview: [],
  gameReviewDone: false,
  bestMoves: [],
  depth: null,
  analyzedGame: [],
  game: null,
  positionIndex: 0,
  gameLength: 0,
  analysisPossible: true,
  elo: 1200,
  startFen: null,
};

export const [
  useAnalysis,
  {
    startNewGamereview,
    setGameReviewPosition,
    setGameReview,
    // setStartFen,
    // setElo,
    setAnalysisStart,
    setAnalysis,
    updateAnalysisPosition,
    analysisNotPossible,
    // setLastMove,
    // setBestMove,
    resetAnalysis,
  },
  analysisStore,
] = createReduxModule("analysis", initialState, {
  startNewGamereview: (state, { gameTime, elo, startFen }) => ({
    ...state,
    gameTime,
    depth: getStartDepth(gameTime),
    gameReview: [
      {
        fen: startFen,
        move: null,
        depth: 18,
        score: 0.26,
        expectedPoints: 0.52,
        type: null,
        bestMove: "d2d4",
        pvMoves: [],
        moveIndex: 0,
      },
    ],
    gameReviewDone: false,
    elo,
    startFen:
      startFen || "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1",
  }),
  setGameReviewPosition: (state, gameReviewPosition) => {
    return {
      ...state,
      gameReview: [...state.gameReview, gameReviewPosition],
      // depth,
    };
  },
  setGameReview: (state, gameReview) => ({
    ...state,
    gameReview,
    gameReviewDone: true,
  }),
  // setStartFen: (state, fen) => ({
  //   ...state,
  //   startFen: fen,
  // }),
  // setElo: (state, elo) => ({
  //   ...state,
  //   elo,
  // }),
  setAnalysisStart: (
    state,
    { gameLength, gameId, fullGame, playingWhite }
  ) => ({
    ...state,
    gameLength,
    currentGameId: gameId,
    analysisPossible: true,
    positionIndex: 0,
    fullGame,
    analyzedGame: [],
    playingWhite,
  }),
  setAnalysis: (
    state,
    payload: { ply: number; analysedMove: AnalysisMoveDone }
  ) => {
    const { ply, analysedMove } = payload;
    if (state.analyzedGame.length > ply) {
      return {
        ...state,
        analyzedGame: state.analyzedGame.map((item, index) => {
          if (index !== ply) {
            return item;
          }
          return {
            ...item,
            ...analysedMove,
          };
        }),
      };
    } else {
      return {
        ...state,
        analyzedGame: [...state.analyzedGame, analysedMove],
      };
    }
  },
  updateAnalysisPosition: (state, positionIndex) => ({
    ...state,
    positionIndex,
  }),
  analysisNotPossible: (state) => ({
    ...state,
    analysisPossible: false,
  }),
  // setLastMove: (state, lastMove) => ({
  //   ...state,
  //   lastMove,
  // }),
  // setBestMove: (state, bestMove) => ({
  //   ...state,
  //   bestMove,
  // }),
  resetAnalysis: () => initialState,
});

function getStartDepth(gameTime: number) {
  let startDepth = 4 + Math.round(gameTime / 60000);
  if (startDepth > 10) {
    startDepth = 10;
  }
  return startDepth;
}

// export async function analyzePosition(fen: string, move: UciMove) {
//   const { gameReview, depth, elo } = analysisStore.getState();

//   const moveIndex = gameReview.length;
//   const isNewGame = moveIndex == 1;
//   // const previousExpectedPoints = gameReview[moveIndex - 1].expectedPoints;
//   // const previousScore = gameReview[moveIndex - 1].score;
//   // const previousBestMove = gameReview[moveIndex - 1].bestMove;

//   const startTime = performance.now();
//   // const uciMoves = moves.map((move) => move.from + move.to);

//   const gameReviewPosition: GameReviewPosition = await calculatePosition(
//     fen,
//     move,
//     moveIndex,
//     // 18,
//     isNewGame,
//     elo
//     // previousExpectedPoints,
//     // previousBestMove
//   );

//   // const completionTime = performance.now() - startTime;
//   // let newDepth: number = depth;
//   // if (completionTime > 1000) {
//   //   newDepth--;
//   //   if (newDepth < 1) {
//   //     newDepth = 1;
//   //   }
//   // } else if (completionTime < 200) {
//   //   newDepth += 3;
//   // } else if (completionTime < 400) {
//   //   newDepth += 2;
//   // } else if (completionTime < 600) {
//   //   newDepth++;
//   // }
//   // newDepth = Math.min(15, newDepth);

//   setGameReviewPosition(gameReviewPosition);

//   console.log(analysisStore.getState().gameReview);
// }

export async function analyzeGameOnServer() {
  // const { gameReview } = analysisStore.getState();
  // const resoponse = await api.post("/game-review", { gameReview });
  // const { gameReview: updatedGameReview } = resoponse.data;
  // setGameReview(updatedGameReview);

  import("../modules/gameReview/createGameReview").then((module) => {
    const { createGameReview } = module;
    createGameReview();
  });
}
